export const getId = state => state.id;
export const getUserId = state => state.userId;
export const getGladlyCustomerId = state => state.gladlyCustomerId;
export const getName = state => state.name;
export const getEmail = state => state.email;

export default {
  getId,
  getUserId,
  getGladlyCustomerId,
  getName,
  getEmail,
};
